<template>
  <div class="forms-elements print-temp">
    <div class="vertical-sidenav sidenav-container-layout">
      <!-- Sidenav for Print Template -->
      <div class="sidenav">
        <b-nav
          vertical
          class="side-nav-content custom-print-sidenav"
          style="width: 400px !important;"
        >
          <div class="sidenav-container-layout">
            <div>
              <!-- options -->
              <b-tabs v-model="tabIndex" class="nav-cols custom-line-tab border-tab mt-2">
                <!-- Template Tab -->
                <b-tab title="Template" class="px-pad py-3 mt-2 mr-4" active>
                  <b-form data-vv-scope="temp_prop_tab">
                    <b-row class="ml-0">
                      <b-col class="px-0">
                        <!-- Template Name -->
                        <b-form-group
                          :label="'Template Name'"
                          label-class="required"
                          label-for="temp_name"
                          class="mb-4"
                        >
                          <b-form-input
                            disabled
                            name="temp_name"
                            :class="{'is-invalid':temp_has_error&&errors.has('temp_prop_tab.temp_name')}"
                            v-validate="'required|max:50'"
                            v-model="temp_prop.temp_name"
                          />
                        </b-form-group>
                        <!-- Paper Size -->
                        <b-form-group
                          horizontal
                          label="Paper Size"
                          class="mb-4"
                          label-for="paper_size"
                        >
                          <b-form-radio-group
                            class="mt-1"
                            v-model="temp_prop.paper_size"
                            :options="papersize"
                          />
                        </b-form-group>

                        <!-- Margins -->
                        <b-form-group
                          label="Margins(in Inches)"
                          label-class="required"
                          label-for="margins"
                          class="mb-4"
                        >
                          <div style="display:inline-flex">
                            <!-- Margin Top -->
                            <b-col sm="3" class="pl-0 pr-2">
                              <b-form-input
                                name="margin_top"
                                :class="{'is-invalid':temp_has_error&&errors.has('temp_prop_tab.margin_top')}"
                                v-validate="{min_value:0,max_value:temp_prop.paper_size==0?1.5:2}"
                                v-model="temp_prop.margin_top"
                              />
                              <small class="text-muted">Top</small>
                            </b-col>
                            <!-- Margin bottom -->
                            <b-col sm="3" class="pl-0 pr-2">
                              <b-form-input
                                name="margin_bottom"
                                :class="{'is-invalid':temp_has_error&&errors.has('temp_prop_tab.margin_bottom')}"
                                v-validate="{min_value:0,max_value:temp_prop.paper_size==0?1.5:2}"
                                v-model="temp_prop.margin_bottom"
                              />
                              <small class="text-muted">Bottom</small>
                            </b-col>
                            <!--Margin left  -->
                            <b-col sm="3" class="pl-0 pr-2">
                              <b-form-input
                                name="margin_left"
                                :class="{'is-invalid':temp_has_error&&errors.has('temp_prop_tab.margin_left')}"
                                v-validate="{min_value:0,max_value:temp_prop.paper_size==0?1.5:2}"
                                v-model="temp_prop.margin_left"
                              />
                              <small class="text-muted">Left</small>
                            </b-col>
                            <!-- Margin right -->
                            <b-col sm="3" class="pl-0 pr-0">
                              <b-form-input
                                name="margin_right"
                                :class="{'is-invalid':temp_has_error&&errors.has('temp_prop_tab.margin_right')}"
                                v-validate="{min_value:0,max_value:temp_prop.paper_size==0?1.5:2}"
                                v-model="temp_prop.margin_right"
                              />
                              <small class="text-muted">Right</small>
                            </b-col>
                          </div>
                        </b-form-group>

                        <b-form-group
                          v-if="temp_prop.hasOwnProperty('bg_color')"
                          class="mb-4"
                          horizontal
                          label="Background Color"
                          label-for="temp_bg_color"
                          :label-cols="5"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <!-- Show Field -->
                            <div class="abc-checkbox" style="padding-top:5px;">
                              <input
                                type="checkbox"
                                id="temp_bg_color"
                                :true-value="1"
                                :false-value="0"
                                v-model="temp_prop.bg_color.show"
                              />
                              <label for="temp_bg_color"></label>
                            </div>
                            <!-- Color Picker -->
                            <input
                              type="text"
                              class="form-control"
                              disabled
                              :value="temp_prop.bg_color.value.hex"
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_17 }"
                              v-model="temp_prop.bg_color.value"
                            />
                            <b-input-group-text
                              @click="colorPickerActive.color_17 = !colorPickerActive.color_17"
                              slot="append"
                              style="padding:5px !important;"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': temp_prop.bg_color.value.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group
                          v-if="temp_prop.hasOwnProperty('label_color')"
                          class="mb-4"
                          horizontal
                          label="Label Color"
                          label-for="temp_label_color"
                          :label-cols="5"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <!-- Show Field -->

                            <!-- Color Picker -->
                            <input
                              type="text"
                              class="form-control"
                              disabled
                              :value="temp_prop.label_color.hex"
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_18 }"
                              v-model="temp_prop.label_color"
                            />
                            <b-input-group-text
                              @click="colorPickerActive.color_18 = !colorPickerActive.color_18"
                              slot="append"
                              style="padding:5px !important;"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': temp_prop.label_color.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group
                          v-if="temp_prop.hasOwnProperty('font_color')"
                          class="mb-4"
                          horizontal
                          label="Font Color"
                          label-for="temp_font_color"
                          :label-cols="5"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <!-- Show Field -->

                            <!-- Color Picker -->
                            <input
                              type="text"
                              class="form-control"
                              disabled
                              :value="temp_prop.font_color.hex"
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_19 }"
                              v-model="temp_prop.font_color"
                            />
                            <b-input-group-text
                              @click="colorPickerActive.color_19 = !colorPickerActive.color_19"
                              slot="append"
                              style="padding:5px !important;"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': temp_prop.font_color.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>
                        <b-form-group
                          v-if="temp_prop.hasOwnProperty('font_size')"
                          horizontal
                          label="Font Size"
                          label-for="temp_font_size"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group append="pt">
                            <b-form-input
                              name="temp_font_size"
                              :class="{'is-invalid':header_has_error&&errors.has('temp_prop_tab.temp_font_size')}"
                              v-validate="'min_value:0|max_value:18'"
                              v-model="temp_prop.font_size"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-tab>
                <!-- Header Tab -->
                <b-tab title="Header" class="px-pad py-3 mt-2 mr-4">
                  <b-form data-vv-scope="header_prop_tab">
                    <b-row class="ml-0">
                      <b-col class="px-0">
                        <!-- Showing Organization Logo -->
                        <b-form-group class="mb-4">
                          <div class="abc-checkbox">
                            <input
                              type="checkbox"
                              id="org_logo_show"
                              :true-value="1"
                              :false-value="0"
                              v-model="header_prop.show_logo"
                            />
                            <label
                              for="org_logo_show"
                              style="padding-top:2px;"
                            >Showing Organization Logo</label>
                          </div>
                        </b-form-group>
                        <!-- resize logo -->
                        <b-form-group
                          class="mb-4"
                          v-if="header_prop.show_logo==1"
                          label="Resize Logo"
                          horizontal
                          label-for="resize_logo"
                          :label-cols="4"
                        >
                          <b-form-slider
                            @change="findHieght($event)"
                            v-model="header_prop.logo_width"
                            :max="240"
                            :min="50"
                          />
                        </b-form-group>
                        <!-- Show Organization Name -->
                        <b-form-group class="mb-4">
                          <div class="abc-checkbox">
                            <input
                              type="checkbox"
                              id="org_name_show"
                              :true-value="1"
                              :false-value="0"
                              v-model="header_prop.show_org_name"
                            />
                            <label
                              for="org_name_show"
                              style="padding-top:2px;"
                            >Show Organization Name</label>
                          </div>
                        </b-form-group>
                        <!-- Show Organization Address -->
                        <b-form-group class="mb-4">
                          <div class="abc-checkbox">
                            <input
                              type="checkbox"
                              id="org_addr_show"
                              :true-value="1"
                              :false-value="0"
                              v-model="header_prop.show_org_addr"
                            />
                            <label
                              for="org_addr_show"
                              style="padding-top:2px;"
                            >Show Organization Address</label>
                          </div>
                        </b-form-group>
                        <!-- Show Document Title -->
                        <b-form-group class="mb-4">
                          <div class="abc-checkbox">
                            <input
                              type="checkbox"
                              id="doc_title_show"
                              :true-value="1"
                              :false-value="0"
                              v-model="header_prop.show_doc_title"
                            />
                            <label for="doc_title_show" style="padding-top:2px;">Show Document Title</label>
                          </div>
                        </b-form-group>
                        <!-- Document Title Label -->
                        <b-form-group class="mb-4">
                          <b-form-input
                            v-model="header_prop.doc_title"
                            name="doc_title_label"
                            v-validate="'max:50'"
                            :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_title_label')}"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <!-- Organization Details -->
                    <b-row class="my-2 ml-0">
                      <b-col class="px-0">
                        <h6 class="mb-3 h6-lg text-link">Organization</h6>

                        <!-- Organization Name Color -->
                        <b-form-group
                          horizontal
                          label="Name Color"
                          label-for="org_name_color"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group class="colorpicker-wrapper">
                            <input
                              type="text"
                              class="form-control"
                              :value="header_prop.org_name_color.hex"
                              disabled
                            />
                            <Sketch
                              :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_3 }"
                              v-model="header_prop.org_name_color"
                            />
                            <b-input-group-text
                              style="padding:5px !important;"
                              @click="colorPickerActive.color_3 = !colorPickerActive.color_3"
                              slot="append"
                            >
                              <div
                                class="append_square"
                                :style="{ 'background-color': header_prop.org_name_color.hex  }"
                              ></div>
                            </b-input-group-text>
                          </b-input-group>
                        </b-form-group>

                        <!-- Organization Name Size -->
                        <b-form-group
                          horizontal
                          label="Name Size"
                          label-for="name_size"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-input-group append="pt">
                            <b-form-input
                              name="org_name_size"
                              :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.org_name_size')}"
                              v-validate="'min_value:0|max_value:18'"
                              v-model="header_prop.org_name_size"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                        <!-- Organization Phone -->
                        <b-form-group
                          horizontal
                          label="Phone"
                          label-for="phone"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-form-input
                            name="org_phone_no"
                            :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.org_phone_no')}"
                            v-validate="'max:50'"
                            v-model="header_prop.phone"
                          ></b-form-input>
                        </b-form-group>
                        <!-- Organization Fax -->
                        <!-- <b-form-group
                          v-if="header_prop.hasOwnProperty('fax')"
                          horizontal
                          label="Fax"
                          label-for="fax"
                          :label-cols="5"
                          class="mb-4"
                        >
                          <b-form-input
                            name="org_fax_no"
                            :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.org_fax_no')}"
                            v-validate="'max:50'"
                            v-model="header_prop.fax"
                          ></b-form-input>
                        </b-form-group>-->
                      </b-col>
                    </b-row>
                    <!-- Customer Name Field -->
                    <b-row class="pb-2">
                      <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                        <!-- Show Customer Name Label -->
                        <div class="abc-checkbox">
                          <input
                            type="checkbox"
                            id="cus_label"
                            :true-value="1"
                            :false-value="0"
                            v-model="header_prop.cus_label.show"
                          />
                          <label for="cus_label" style="padding-top:2px;">Customer Name</label>
                        </div>
                      </b-col>

                      <b-col sm="7" style="padding-left: 7px !important">
                        <!-- Date Label -->
                        <b-form-input
                          name="cus_label_label"
                          :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.cus_label_label')}"
                          v-validate="'max:50'"
                          :disabled="header_prop.cus_label.show==0"
                          v-model="header_prop.cus_label.label"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                    <!-- Customer Phone Field -->
                    <b-row class="pb-2">
                      <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                        <!-- Show Customer Phone Label -->
                        <div class="abc-checkbox">
                          <input
                            type="checkbox"
                            id="cus_ph_label"
                            :true-value="1"
                            :false-value="0"
                            v-model="header_prop.cus_ph_label.show"
                          />
                          <label for="cus_ph_label" style="padding-top:2px;">Customer Phone</label>
                        </div>
                      </b-col>

                      <b-col sm="7" style="padding-left: 7px !important">
                        <!-- Date Label -->
                        <b-form-input
                          name="cus_ph_label_label"
                          :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.cus_ph_label_label')}"
                          v-validate="'max:50'"
                          :disabled="header_prop.cus_ph_label.show==0"
                          v-model="header_prop.cus_ph_label.label"
                        ></b-form-input>
                      </b-col>
                    </b-row>

                    <!-- Document Information -->
                    <b-row class="mb-2 mt-4 ml-0">
                      <b-col class="px-0">
                        <h6 class="mb-3 h6-lg text-link">Document Information</h6>
                        <b-form-group class="mb-4">
                          <!-- Number Field -->
                          <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Number Field Label -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="num_field"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.num_field.show"
                                />
                                <label for="num_field" style="padding-top:2px;">Number Field</label>
                              </div>
                            </b-col>

                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Date Label -->
                              <b-form-input
                                name="num_field_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.num_field_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.num_field.show==0"
                                v-model="header_prop.num_field.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- Date Field -->
                          <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Date Label -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_date"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.doc_date.show"
                                />
                                <label for="doc_date" style="padding-top:2px;">Date Field</label>
                              </div>
                            </b-col>

                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Date Label -->
                              <b-form-input
                                name="doc_date_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_date_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.doc_date.show==0"
                                v-model="header_prop.doc_date.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <!-- Invoice Date Field -->
                          <!-- <b-row v-if="menu_id==3" class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                             
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_inv_date"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.doc_inv_date.show"
                                />
                                <label
                                  for="doc_inv_date"
                                  style="padding-top:2px;"
                                >Invoice Date Field</label>
                              </div>
                            </b-col>

                            <b-col sm="7" style="padding-left: 7px !important">
                            
                              <b-form-input
                                name="doc_inv_date_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_inv_date_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.doc_inv_date.show==0"
                                v-model="header_prop.doc_inv_date.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>-->

                          <!-- Salesperson Field  -->
                          <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Salesperson Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="sales_person"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.doc_sales_person.show"
                                />
                                <label for="sales_person" style="padding-top:2px;">Salesperson</label>
                              </div>
                            </b-col>
                            <!-- Salesperson Label -->
                            <b-col sm="7" style="padding-left: 7px !important">
                              <b-form-input
                                name="sales_person_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.sales_person_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.doc_sales_person.show==0"
                                v-model="header_prop.doc_sales_person.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>

                          <!-- Place of Supply Field -->
                          <b-row class="pb-2">
                            <b-col sm="5" class="pr-0" style="padding-top: 7px !important;">
                              <!-- Show Place of Supply -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="doc_place_supply"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="header_prop.doc_place_supply.show"
                                />
                                <label
                                  for="doc_place_supply"
                                  style="padding-top:2px;"
                                >Place of Supply</label>
                              </div>
                            </b-col>
                            <b-col sm="7" style="padding-left: 7px !important">
                              <!-- Place of Supply Label -->
                              <b-form-input
                                name="doc_place_supply_label"
                                :class="{'is-invalid':header_has_error&&errors.has('header_prop_tab.doc_place_supply_label')}"
                                v-validate="'max:50'"
                                :disabled="header_prop.doc_place_supply.show==0"
                                v-model="header_prop.doc_place_supply.label"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-tab>
                <!-- Item Properties -->
                <b-tab title="Product" class="px-pad py-3 mt-2 mr-4">
                  <b-row class="ml-0">
                    <b-tabs
                      v-model="itemTabIndex"
                      class="nav-cols custom-line-tab button-nav button-tab"
                    >
                      <!-- Label Tab -->
                      <b-tab title="Labels" class="px-0" active>
                        <b-form data-vv-scope="item_label_prop_tab">
                          <!-- Header For Fields -->
                          <b-row class="mx-1">
                            <b-col sm="5" class="p-0" style="padding-top: 7px !important;"></b-col>
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-2">Width(%)</b-col>
                                <b-col sm="8" class="px-2">Label</b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <!-- Line Item No Field -->
                          <b-row class="pb-2 mx-1 mt-3">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- Show field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="line_item_no"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.item_no.show"
                                />
                                <label
                                  for="line_item_no"
                                  style="padding-top:2px;"
                                >Line Product Number</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    name="item_no_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_no_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.item_no.show==0"
                                    v-model="item_prop.label.item_no.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="item_no_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_no_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.item_no.show==0"
                                    v-model="item_prop.label.item_no.label"
                                  ></b-form-input>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <!-- item field -->
                          <b-row class="pb-2 mx-1 mt-3">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="line_item"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.item.show"
                                  :disabled="item_prop.label.desc.show==0"
                                />
                                <label for="line_item" style="padding-top:2px;">Product</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    name="item_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.item.show==0"
                                    v-model="item_prop.label.item.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="item_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.item.show==0"
                                    v-model="item_prop.label.item.label"
                                  ></b-form-input>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2 mx-1 mt-3">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="item_desc"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.desc.show"
                                  :disabled="item_prop.label.item.show==0"
                                />
                                <label for="item_desc" style="padding-top:2px;">Description</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    v-if="item_prop.label.item.show==0"
                                    name="desc_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.desc_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.desc.show==0"
                                    v-model="item_prop.label.desc.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="item_desc_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_desc_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.desc.show==0"
                                    v-model="item_prop.label.desc.label"
                                  ></b-form-input>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <!-- Quantity field -->
                          <b-row class="pb-2 mx-1 mt-3">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="item_qty"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.qty.show"
                                />
                                <label for="item_qty" style="padding-top:2px;">Quantity</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    name="item_qty_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_qty_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.qty.show==0"
                                    v-model="item_prop.label.qty.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="item_qty_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_qty_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.qty.show==0"
                                    v-model="item_prop.label.qty.label"
                                  ></b-form-input>

                                  <!-- Show unit -->
                                  <small>
                                    <div class="abc-checkbox pt-2">
                                      <input
                                        type="checkbox"
                                        plain
                                        id="item_unit"
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="item_prop.label.qty.show_unit"
                                        :disabled="item_prop.label.qty.show==0"
                                      />
                                      <label for="item_unit" style="padding-top:2px;">Show Unit</label>
                                    </div>
                                  </small>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <b-row class="pb-2 mx-1 mt-3">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="item_hsn_label"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.hsn.show"
                                />
                                <label for="item_hsn_label" style="padding-top:2px;">HSN/SAC Label</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    name="item_hsn_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_hsn_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.hsn.show==0"
                                    v-model="item_prop.label.hsn.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="item_hsn_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_hsn_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.hsn.show==0"
                                    v-model="item_prop.label.hsn.label"
                                  ></b-form-input>
                                  <!-- Show unit -->
                                  <small>
                                    <div class="abc-checkbox pt-2">
                                      <input
                                        type="checkbox"
                                        plain
                                        id="item_hsn"
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="item_prop.label.hsn.show_in_desc"
                                        :disabled="item_prop.label.hsn.show==0"
                                      />
                                      <label
                                        for="item_hsn"
                                        style="padding-top:2px;"
                                      >Show Below Description</label>
                                    </div>
                                  </small>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <!-- Rate field -->
                          <b-row class="pb-2 mx-1 mt-3">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="item_rate"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.rate.show"
                                />
                                <label for="item_rate" style="padding-top:2px;">Rate</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    name="rate_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.rate_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.rate.show==0"
                                    v-model="item_prop.label.rate.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="rate_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.rate_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.rate.show==0"
                                    v-model="item_prop.label.rate.label"
                                  ></b-form-input>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <!-- Discount field -->
                          <b-row class="pb-2 mx-1 mt-3">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="item_discount"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.discount.show"
                                />
                                <label
                                  for="item_discount"
                                  style="padding-top:2px;"
                                >{{ menu_id == 5 || menu_id ==10 ? 'EAN' : 'Discount'}}</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    name="discount_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.discount_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.discount.show==0"
                                    v-model="item_prop.label.discount.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="discount_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.discount_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.discount.show==0"
                                    v-model="item_prop.label.discount.label"
                                  ></b-form-input>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <!-- Tax field -->
                          <b-row class="pb-2 mx-1 mt-3">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="item_tax"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.tax.show"
                                />
                                <label for="item_tax" style="padding-top:2px;">Tax (%)</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    name="item_tax_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_tax_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.tax.show==0"
                                    v-model="item_prop.label.tax.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="item_tax_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_tax_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.tax.show==0"
                                    v-model="item_prop.label.tax.label"
                                  ></b-form-input>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>

                          <!-- Amount field -->
                          <b-row class="pb-2 mx-1 mt-3">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="tax_amt"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.tax_amt.show"
                                />
                                <label for="tax_amt" style="padding-top:2px;">Tax Amount</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    name="tax_amt_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.tax_amt_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.tax_amt.show==0"
                                    v-model="item_prop.label.tax_amt.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="tax_amt_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.tax_amt_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.tax_amt.show==0"
                                    v-model="item_prop.label.tax_amt.label"
                                  ></b-form-input>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>

                          <!-- Amount field -->
                          <b-row class="pb-2 mx-1 mt-3">
                            <b-col sm="5" class="px-1" style="padding-top: 7px !important;">
                              <!-- show Field -->
                              <div class="abc-checkbox">
                                <input
                                  type="checkbox"
                                  id="item_amt"
                                  :true-value="1"
                                  :false-value="0"
                                  v-model="item_prop.label.amt.show"
                                />
                                <label for="item_amt" style="padding-top:2px;">Amount</label>
                              </div>
                            </b-col>
                            <!-- Width and Label values -->
                            <b-col sm="7">
                              <b-row>
                                <b-col sm="4" class="px-1">
                                  <b-form-input
                                    name="item_amt_width"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_amt_width')}"
                                    v-validate="'max_value:100'"
                                    :disabled="item_prop.label.amt.show==0"
                                    v-model="item_prop.label.amt.width"
                                  ></b-form-input>
                                </b-col>
                                <b-col sm="8" class="px-1">
                                  <b-form-input
                                    name="item_amt_label"
                                    :class="{'is-invalid':item_label_has_error&&errors.has('item_label_prop_tab.item_amt_label')}"
                                    v-validate="'max:50'"
                                    :disabled="item_prop.label.amt.show==0"
                                    v-model="item_prop.label.amt.label"
                                  ></b-form-input>
                                  <!-- Show unit -->
                                  <!-- <small>
                                    <div class="abc-checkbox pt-2">
                                      <input
                                        type="checkbox"
                                        plain
                                        id="add_tax_amt"
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="item_prop.label.amt.add_tax_amt"
                                        :disabled="item_prop.label.amt.show==0"
                                      />
                                      <label
                                        for="add_tax_amt"
                                        style="padding-top:2px;"
                                      >Add tax to amount</label>
                                    </div>
                                  </small>-->
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                        </b-form>
                      </b-tab>
                      <!-- Layout Tab -->
                      <b-tab title="Layout">
                        <!-- Table Border -->
                        <b-form data-vv-scope="item_layout_prop_tab">
                          <b-row class="mb-2 mt-4 ml-0">
                            <b-col class="px-0">
                              <!-- Table border color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Table Border"
                                label-for="tbl_border"
                                :label-cols="5"
                              >
                                <b-input-group class="colorpicker-wrapper">
                                  <!-- Show Field -->
                                  <div class="abc-checkbox" style="padding-top:5px;">
                                    <input
                                      type="checkbox"
                                      id="tbl_border_color"
                                      :true-value="1"
                                      :false-value="0"
                                      v-model="item_prop.layout.table_border.show"
                                    />
                                    <label for="tbl_border_color"></label>
                                  </div>
                                  <!-- Color Picker -->
                                  <input
                                    type="text"
                                    class="form-control"
                                    disabled
                                    :value="item_prop.layout.table_border.value.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_5 }"
                                    v-model="item_prop.layout.table_border.value"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_5  = !colorPickerActive.color_5 "
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': item_prop.layout.table_border.value.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                          <!-- Table Header Fields -->
                          <b-row class="my-2 ml-0">
                            <b-col class="px-0">
                              <h6 class="mb-3 h6-lg text-link">Product Row</h6>
                              <!-- Table Header Font Size -->
                              <b-form-group
                                class="mb-4"
                                label="Font Size"
                                horizontal
                                label-for="item_row_font_size"
                                :label-cols="5"
                              >
                                <b-input-group append="pt">
                                  <b-form-input
                                    name="item_row_font_size"
                                    :class="{'is-invalid':item_layout_has_error&&errors.has('item_layout_prop_tab.item_row_font_size')}"
                                    v-validate="'min_value:0|max_value:18'"
                                    v-model="item_prop.layout.item_row_font_size"
                                  ></b-form-input>
                                </b-input-group>
                              </b-form-group>
                              <!-- Table Header Background color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Background Color"
                                label-for="item_row_bg_color"
                                :label-cols="5"
                              >
                                <b-input-group class="colorpicker-wrapper">
                                  <!-- Show Field -->
                                  <div class="abc-checkbox" style="padding-top:5px;">
                                    <input
                                      type="checkbox"
                                      id="item_row_bg_color"
                                      :true-value="1"
                                      :false-value="0"
                                      v-model="item_prop.layout.item_row_bg_color.show"
                                    />
                                    <label for="item_row_bg_color"></label>
                                  </div>
                                  <!-- Color Picker -->
                                  <input
                                    type="text"
                                    class="form-control"
                                    disabled
                                    :value="item_prop.layout.item_row_bg_color.value.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_6 }"
                                    v-model="item_prop.layout.item_row_bg_color.value"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_6 = !colorPickerActive.color_6"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': item_prop.layout.item_row_bg_color.value.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                              <!-- Table Header font Color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Font Color"
                                label-for="item_row_font_color"
                                :label-cols="5"
                              >
                                <!-- Color Picker -->
                                <b-input-group class="colorpicker-wrapper">
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="item_prop.layout.item_row_font_color.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_7 }"
                                    v-model="item_prop.layout.item_row_font_color"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_7 = !colorPickerActive.color_7"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': item_prop.layout.item_row_font_color.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>

                          <!-- Table Header Fields -->
                          <b-row class="my-2 ml-0">
                            <b-col class="px-0">
                              <h6 class="mb-3 h6-lg text-link">Table Header</h6>
                              <!-- Table Header Font Size -->
                              <b-form-group
                                class="mb-4"
                                label="Font Size"
                                horizontal
                                label-for="tbl_hdr_size"
                                :label-cols="5"
                              >
                                <b-input-group append="pt">
                                  <b-form-input
                                    name="tbl_hdr_size"
                                    :class="{'is-invalid':item_layout_has_error&&errors.has('item_layout_prop_tab.tbl_hdr_size')}"
                                    v-validate="'min_value:0|max_value:18'"
                                    v-model="item_prop.layout.header_font_size"
                                  ></b-form-input>
                                </b-input-group>
                              </b-form-group>
                              <!-- Table Header Background color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Background Color"
                                label-for="tbl_hdr_bg"
                                :label-cols="5"
                              >
                                <b-input-group class="colorpicker-wrapper">
                                  <!-- Show Field -->
                                  <div class="abc-checkbox" style="padding-top:5px;">
                                    <input
                                      type="checkbox"
                                      id="tbl_hdr_bg_color"
                                      :true-value="1"
                                      :false-value="0"
                                      v-model="item_prop.layout.bg_color.show"
                                    />
                                    <label for="tbl_hdr_bg_color"></label>
                                  </div>
                                  <!-- Color Picker -->
                                  <input
                                    type="text"
                                    class="form-control"
                                    disabled
                                    :value="item_prop.layout.bg_color.value.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_2 }"
                                    v-model="item_prop.layout.bg_color.value"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_2 = !colorPickerActive.color_2"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': item_prop.layout.bg_color.value.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                              <!-- Table Header font Color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Font Color"
                                label-for="tbl_hdr_font_color"
                                :label-cols="5"
                              >
                                <!-- Color Picker -->
                                <b-input-group class="colorpicker-wrapper">
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="item_prop.layout.header_font_color.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_4 }"
                                    v-model="item_prop.layout.header_font_color"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_4 = !colorPickerActive.color_4"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': item_prop.layout.header_font_color.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                          <!-- Item Description Fields -->

                          <b-row
                            class="my-2 ml-0"
                            :style="{'margin-bottom':colorPickerActive.color_8?'310px':colorPickerActive.color_7?'100px':colorPickerActive.color_6?'50px':'unset'}"
                          >
                            <b-col class="px-0">
                              <h6 class="mb-3 h6-lg text-link">Product Description</h6>
                              <!-- Item Description Font Size -->
                              <b-form-group
                                class="mb-4"
                                label="Font Size"
                                horizontal
                                label-for="itm_desc_font_size"
                                :label-cols="5"
                              >
                                <b-input-group append="pt">
                                  <b-form-input
                                    name="itm_desc_font_size"
                                    :class="{'is-invalid':item_layout_has_error&&errors.has('item_layout_prop_tab.itm_desc_font_size')}"
                                    v-validate="'min_value:0|max_value:18'"
                                    v-model="item_prop.layout.item_font_size"
                                  ></b-form-input>
                                </b-input-group>
                              </b-form-group>
                              <!-- Item Description Font Color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Font Color"
                                label-for="desc_bg_color"
                                :label-cols="5"
                              >
                                <b-input-group class="colorpicker-wrapper">
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="item_prop.layout.item_font_color.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_8 }"
                                    v-model="item_prop.layout.item_font_color"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_8  = !colorPickerActive.color_8 "
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': item_prop.layout.item_font_color.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-form>
                      </b-tab>
                    </b-tabs>
                  </b-row>
                </b-tab>
                <!-- Total Tab -->
                <b-tab title="Total" class="px-pad py-3 mt-2">
                  <b-row class="ml-0">
                    <b-tabs
                      v-model="totalTabIndex"
                      class="nav-cols custom-line-tab button-nav button-tab"
                    >
                      <!-- Label Section -->
                      <b-tab title="Labels" class="px-0" active>
                        <b-form data-vv-scope="total_label_prop_tab">
                          <b-row class="mx-1 mt-4">
                            <b-col sm="12" class="px-1">
                              <!-- Show Total Section -->
                              <b-form-group>
                                <div class="abc-checkbox">
                                  <input
                                    type="checkbox"
                                    id="total_sec_show"
                                    :true-value="1"
                                    :false-value="0"
                                    v-model="total_prop.label.show_total_sec"
                                  />
                                  <label
                                    for="total_sec_show"
                                    style="padding-top:2px;"
                                  >Show Total Section</label>
                                </div>
                              </b-form-group>
                              <!-- Display Only Total section show -->
                              <div v-if="total_prop.label.show_total_sec==1">
                                <!-- Sub Total Field -->
                                <b-row class="my-3">
                                  <b-col sm="5" style="padding-top: 7px !important;">
                                    <!-- Show Sub Total -->
                                    <div class="abc-checkbox">
                                      <input
                                        type="checkbox"
                                        id="sub_total"
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="total_prop.label.sub_total.show"
                                      />
                                      <label for="sub_total" style="padding-top:2px;">Sub Total</label>
                                    </div>
                                  </b-col>
                                  <b-col class="pl-2" sm="7">
                                    <!-- Sub Total Lable -->
                                    <b-form-input
                                      name="sub_total_label"
                                      :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.sub_total_label')}"
                                      v-validate="'max:50'"
                                      :disabled="total_prop.label.sub_total.show==0"
                                      v-model="total_prop.label.sub_total.label"
                                    ></b-form-input>
                                  </b-col>
                                </b-row>
                                <!-- TDS Setion -->

                                <b-form-group
                                  v-if="total_prop.label.hasOwnProperty('shipping_charge')"
                                  class="pb-1"
                                  :label="'Shipping Charge'"
                                  horizontal
                                  label-for="shipping_charge"
                                  :label-cols="5"
                                >
                                  <b-form-input
                                    name="shipping_charge"
                                    :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.shipping_charge')}"
                                    v-validate="'max:50'"
                                    v-model="total_prop.label.shipping_charge"
                                  ></b-form-input>
                                </b-form-group>

                                <!-- <b-row
                                  class="my-3"
                                  v-if="total_prop.label.hasOwnProperty('shipping_charge_sac')"
                                >
                                <b-col sm="5" style="padding-top: 7px !important;">-->
                                <!-- Show Total Taxable Amount-->
                                <!-- <div class="abc-checkbox">
                                      <input
                                        type="checkbox"
                                        id="shipping_charge_sac"
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="total_prop.label.shipping_charge_sac.show"
                                      />
                                      <label
                                        for="shipping_charge_sac"
                                        style="padding-top:2px;"
                                      >Shipping Charge SAC</label>
                                    </div>
                                  </b-col>
                                <b-col class="pl-2" sm="7">-->
                                <!-- Total Taxable Amount Lable -->
                                <!-- <b-form-input
                                      name="shipping_charge_sac_label"
                                      :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.shipping_charge_sac')}"
                                      v-validate="'max:50'"
                                      :disabled="total_prop.label.shipping_charge_sac.show==0"
                                      v-model="total_prop.label.shipping_charge_sac.label"
                                    ></b-form-input>
                                  </b-col>
                                </b-row>-->
                                <!-- Total Field -->
                                <b-form-group
                                  class="pb-1"
                                  label="Total"
                                  horizontal
                                  label-for="total"
                                  :label-cols="5"
                                >
                                  <b-form-input
                                    name="total_label"
                                    :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.total_label')}"
                                    v-validate="'max:50'"
                                    v-model="total_prop.label.total"
                                  ></b-form-input>
                                </b-form-group>
                                <!-- Show Discount Field -->
                                <b-form-group class="mb-3">
                                  <div class="abc-checkbox">
                                    <input
                                      type="checkbox"
                                      id="discount"
                                      :true-value="1"
                                      :false-value="0"
                                      v-model="total_prop.label.show_discount"
                                    />
                                    <label for="discount" style="padding-top:2px;">Discount</label>
                                  </div>
                                </b-form-group>

                                <b-form-group
                                  label="Currency Symbol"
                                  label-cols="6"
                                  label-for="currency_syb"
                                  v-if="total_prop.label.currency_syb"
                                >
                                  <b-form-radio-group
                                    :options="[{value:1,text:'Before amount'},{value:2,text:'After amount'}]"
                                    v-model="total_prop.label.currency_syb"
                                  ></b-form-radio-group>
                                </b-form-group>
                                <b-form-group>
                                  <div
                                    class="abc-checkbox mb-2"
                                    v-if="total_prop.label.hasOwnProperty('show_total_qty')"
                                  >
                                    <input
                                      type="checkbox"
                                      id="show_total_qty"
                                      :true-value="1"
                                      :false-value="0"
                                      v-model="total_prop.label.show_total_qty"
                                    />
                                    <label for="show_total_qty" style="padding-top:2px;">Quantity</label>
                                  </div>
                                  <b-form-group
                                    v-if="total_prop.label.show_total_qty==1&&total_prop.label.hasOwnProperty('item_in_total')"
                                    class="pb-1"
                                    :label="'Items in Total'"
                                    horizontal
                                    label-for="item_in_total"
                                    :label-cols="5"
                                  >
                                    <b-form-input
                                      name="item_in_total"
                                      :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.item_in_total')}"
                                      v-validate="'max:50'"
                                      v-model="total_prop.label.item_in_total"
                                    ></b-form-input>
                                  </b-form-group>
                                  <!-- <b-form-group
                                    v-if="total_prop.label.show_total_qty==1&&total_prop.label.hasOwnProperty('hour_in_total')"
                                    class="pb-1"
                                    :label="'Hours in Total'"
                                    horizontal
                                    label-for="hour_in_total"
                                    :label-cols="5"
                                  >
                                    <b-form-input
                                      name="hour_in_total"
                                      :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.hour_in_total')}"
                                      v-validate="'max:50'"
                                      v-model="total_prop.label.hour_in_total"
                                    ></b-form-input>
                                  </b-form-group>-->
                                </b-form-group>
                                <div v-if="menu_id==1||menu_id==3 ">
                                  <!-- Show Payment Details -->
                                  <b-form-group class="mt-5">
                                    <div class="abc-checkbox">
                                      <input
                                        type="checkbox"
                                        id="show_pay_detail"
                                        :true-value="1"
                                        :false-value="0"
                                        v-model="total_prop.label.show_pay_detail"
                                      />
                                      <label
                                        for="show_pay_detail"
                                        style="padding-top:2px;"
                                      >Show Payment Details</label>
                                    </div>
                                  </b-form-group>
                                  <!-- Payment Details -->
                                  <div v-if="total_prop.label.show_pay_detail==1">
                                    <template v-if="menu_id==1">
                                      <!-- Payment Made -->
                                      <b-form-group
                                        class="pb-1"
                                        label="Payment Made"
                                        horizontal
                                        label-for="pay_made"
                                        :label-cols="5"
                                      >
                                        <b-form-input
                                          name="pay_made_label"
                                          :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.pay_made_label')}"
                                          v-validate="'max:50'"
                                          v-model="total_prop.label.pay_made"
                                        ></b-form-input>
                                      </b-form-group>
                                      <b-form-group
                                        v-if="total_prop.label.hasOwnProperty('amt_withheld')"
                                        class="pb-1"
                                        :label="'Amount Withheld'"
                                        horizontal
                                        label-for="amt_withheld"
                                        :label-cols="5"
                                      >
                                        <b-form-input
                                          name="amt_withheld"
                                          :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.amt_withheld')}"
                                          v-validate="'max:50'"
                                          v-model="total_prop.label.amt_withheld"
                                        ></b-form-input>
                                      </b-form-group>
                                      <!-- Credits Applied -->
                                      <b-form-group
                                        class="pb-1"
                                        label="Credits Applied"
                                        horizontal
                                        label-for="credit_apply"
                                        :label-cols="5"
                                      >
                                        <b-form-input
                                          name="credit_apply_label"
                                          :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.credit_apply_label')}"
                                          v-validate="'max:50'"
                                          v-model="total_prop.label.credits_apply"
                                        ></b-form-input>
                                      </b-form-group>
                                      <!-- Writeoff amount -->
                                      <b-form-group
                                        class="pb-1"
                                        :label="'Write Off Amount'"
                                        horizontal
                                        label-for="writeoff_amt"
                                        :label-cols="5"
                                        v-if="menu_id==1"
                                      >
                                        <b-form-input
                                          name="writeoff_amt"
                                          :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.writeoff_amt')}"
                                          v-validate="'max:50'"
                                          v-model="total_prop.label.writeoff_amt_label"
                                        ></b-form-input>
                                      </b-form-group>
                                      <!-- Balance Due -->
                                      <b-form-group
                                        class="pb-1"
                                        :label="'Balance Due'"
                                        horizontal
                                        label-for="bal_due"
                                        :label-cols="5"
                                      >
                                        <b-form-input
                                          name="bal_due_label"
                                          :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.bal_due_label')}"
                                          v-validate="'max:50'"
                                          v-model="total_prop.label.bal_due"
                                        ></b-form-input>
                                      </b-form-group>
                                    </template>

                                    <template v-if="menu_id==3">
                                      <!-- Credits Used -->
                                      <b-form-group
                                        class="pb-1"
                                        :label="'Credits Used'"
                                        horizontal
                                        label-for="credits_used"
                                        :label-cols="5"
                                      >
                                        <b-form-input
                                          name="credits_used"
                                          :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.credits_used')}"
                                          v-validate="'max:50'"
                                          v-model="total_prop.label.credits_used"
                                        ></b-form-input>
                                      </b-form-group>
                                      <!-- Credits remaining -->
                                      <b-form-group
                                        class="pb-1"
                                        :label="'Credits Remaining'"
                                        horizontal
                                        label-for="credits_remaining"
                                        :label-cols="5"
                                      >
                                        <b-form-input
                                          name="credits_remaining"
                                          :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.credits_remaining')}"
                                          v-validate="'max:50'"
                                          v-model="total_prop.label.credits_remaining"
                                        ></b-form-input>
                                      </b-form-group>
                                      <!-- Refund -->
                                      <b-form-group
                                        class="pb-1"
                                        :label="'Refund'"
                                        horizontal
                                        label-for="refund"
                                        :label-cols="5"
                                      >
                                        <b-form-input
                                          name="refund"
                                          :class="{'is-invalid':total_label_has_error&&errors.has('total_label_prop_tab.refund')}"
                                          v-validate="'max:50'"
                                          v-model="total_prop.label.refund"
                                        ></b-form-input>
                                      </b-form-group>
                                    </template>
                                  </div>
                                </div>
                              </div>
                              <!-- Show amount in words -->
                            </b-col>
                          </b-row>
                        </b-form>
                      </b-tab>
                      <!-- Layout Details -->
                      <b-tab title="Layout">
                        <b-form data-vv-scope="total_layout_prop_tab">
                          <b-row class="mb-2 mt-4 ml-0">
                            <b-col class="px-0">
                              <!-- Sub total and tax Layouts -->
                              <h6 class="mb-3 h6-lg text-link">Total(Subtotal, Tax)</h6>
                              <b-form-group
                                class="mb-4"
                                label="Font Size"
                                horizontal
                                label-for="total_font_size"
                                :label-cols="5"
                              >
                                <b-input-group append="pt">
                                  <b-form-input
                                    name="total_font_size"
                                    :class="{'is-invalid':total_layout_has_error&&errors.has('total_layout_prop_tab.total_font_size')}"
                                    v-validate="'min_value:0|max_value:18'"
                                    v-model="total_prop.layout.total_font_size"
                                  ></b-form-input>
                                </b-input-group>
                              </b-form-group>
                              <!-- Background Color -->
                              <b-form-group
                                class="mb-4"
                                horizontal
                                label="Background Color"
                                label-for="total_bg_color"
                                :label-cols="5"
                              >
                                <!-- Color Picker -->
                                <b-input-group class="colorpicker-wrapper">
                                  <!-- Apply Background Color -->
                                  <div class="abc-checkbox" style="padding-top:5px;">
                                    <input
                                      type="checkbox"
                                      id="total_bg_color"
                                      :true-value="1"
                                      :false-value="0"
                                      v-model="total_prop.layout.total_bg_color.show"
                                    />
                                    <label for="total_bg_color"></label>
                                  </div>
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="total_prop.layout.total_bg_color.value.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_9  }"
                                    v-model="total_prop.layout.total_bg_color.value"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_9 = !colorPickerActive.color_9"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': total_prop.layout.total_bg_color.value.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                              <!-- Font Color -->
                              <b-form-group
                                style="margin-bottom:290px !important"
                                class="mb-4"
                                horizontal
                                label="Font Color"
                                label-for="total_font_color"
                                :label-cols="5"
                              >
                                <!-- Color Picker -->
                                <b-input-group class="colorpicker-wrapper">
                                  <input
                                    disabled
                                    type="text"
                                    class="form-control"
                                    :value="total_prop.layout.total_font_color.hex"
                                  />
                                  <Sketch
                                    :class="{ colorpicker: true, 'd-none': !colorPickerActive.color_10 }"
                                    v-model="total_prop.layout.total_font_color"
                                  />
                                  <b-input-group-text
                                    @click="colorPickerActive.color_10 = !colorPickerActive.color_10"
                                    slot="append"
                                    style="padding:5px !important;"
                                  >
                                    <div
                                      class="append_square"
                                      :style="{ 'background-color': total_prop.layout.total_font_color.hex  }"
                                    ></div>
                                  </b-input-group-text>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-form>
                      </b-tab>
                    </b-tabs>
                  </b-row>
                </b-tab>
              </b-tabs>
              <!-- Footer for Template settings -->
              <div style="position:fixed;bottom:0;width: 400px;" class="border-top">
                <b-button
                  @click="onSubmit()"
                  size="sm"
                  variant="primary"
                  class="btn-rounded mx-mar my-2"
                >Save</b-button>
              </div>
            </div>
          </div>
        </b-nav>
      </div>
      <div class="sidenave-main-content" style="margin-top:-17px;">
        <b-row class="px-3 border-bottom" style="height:42px;">
          <b-col cols="10" class="px-0">
            <b-button
              @click="preview()"
              size="sm"
              variant="light"
              class="mr-2 mt-1 text-link btn-rounded"
            >
              Preview
              <span>
                <i class="la la-eye la-lg"></i>
              </span>
            </b-button>
            <b-button
              v-b-modal.restoreSettings
              size="sm"
              variant="light"
              class="text-link btn-rounded mt-1"
            >Restore Default</b-button>
          </b-col>
          <b-col cols="2" class="text-right px-0">
            <a @click="redirectPage()" class="mr-2 text-right">
              <i class="la la-remove la-lg text-decoration-none mt-3"></i>
            </a>
          </b-col>
        </b-row>
        <div
          class="sidenav-view-block py-4"
          style="overflow-y: scroll;height: calc(100vh -112px);margin-left: -20px !important;margin-right: -20px !important;"
        >
          <RetailTemplate :list="list" :id="id"></RetailTemplate>
        </div>
      </div>
    </div>
    <!-- modal for restore settings  -->
    <b-modal
      id="restoreSettings"
      title="Restore Default Settings"
      cancel-title="No"
      cancel-variant="light"
      ok-title="Yes"
      @ok="backtodefault()"
    >
      <p>Are you sure you want to restore default settings?</p>
    </b-modal>
  </div>
</template>
 
 <script>
import Vue from "vue";
import { mapState } from "vuex";
import bFormSlider from "vue-bootstrap-slider"; // Slider
import RetailTemplate from "@/components/Form/Settings/Print/Invoice/RetailTemplate";
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import { Sketch } from "vue-color";
Vue.use(bFormSlider); // Use silder
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import store from "@/store/index";
export default {
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: {
    Sketch,
    RetailTemplate
  },
  props: ["id"],

  data() {
    return {
      // color picker value for display
      colorPickerActive: {
        color_1: false,
        color_2: false,
        color_3: false,
        color_4: false,
        color_5: false,
        color_6: false,
        color_7: false,
        color_8: false,
        color_9: false,
        color_10: false,
        color_11: false,
        color_12: false,
        color_13: false,
        color_14: false,
        color_15: false,
        color_16: false,
        color_17: false,
        color_18: false,
        color_19: false
      },
      // Paper size options
      papersize: [
        {
          text: "3'",
          value: "0"
        },
        {
          text: "4'",
          value: "1"
        }
      ],
      tabIndex: 0,
      itemTabIndex: 0,
      totalTabIndex: 0,
      temp_has_error: false,
      header_has_error: false,
      item_label_has_error: false,
      total_label_has_error: false,
      item_layout_has_error: false,
      total_label_has_error: false,
      total_layout_has_error: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // notification design class
    };
  },

  methods: {
    redirectPage() {
      if (this.path) {
        this.$router.push(this.path);
      } else {
        this.$router.push({
          name: "Templates",
          query: {
            stg_menu: this.$route.query.stg_menu,
            template_group: this.$route.query.template_group
          }
        });
      }
    },
    // preview print template
    preview() {
      this.validateForm().then(result => {
        if (result) {
          EventBus.$emit("preview", this.list);
        }
      });
    },

    // validate form details
    async validateForm() {
      // Validate Form template Form
      var validated = false;
      return new Promise((resolve, reject) => {
        this.$validator
          .validateAll("temp_prop_tab")
          .then(result => {
            if (result == false) {
              this.tabIndex = 0;
              // Validation Error
              this.temp_has_error = true;
            } else {
              this.temp_has_error = false;
              // Validate Header tab Form
              this.$validator.validateAll("header_prop_tab").then(result => {
                if (result == false) {
                  this.tabIndex = 1;
                  this.header_has_error = true;
                } else {
                  this.header_has_error = false;
                  // Validate Iteam Tab Label form
                  this.$validator
                    .validateAll("item_label_prop_tab")
                    .then(result => {
                      if (result == false) {
                        this.tabIndex = 2;
                        this.itemTabIndex = 0;
                        this.item_label_has_error = true;
                      } else {
                        this.item_label_has_error = false;
                        // Validate Iteam Tab Layout form
                        this.$validator
                          .validateAll("item_layout_prop_tab")
                          .then(result => {
                            if (result == false) {
                              this.tabIndex = 2;
                              this.itemTabIndex = 1;
                              this.item_layout_has_error = true;
                            } else {
                              this.item_layout_has_error = false;
                              // Validate Total Tab Label form
                              this.$validator
                                .validateAll("total_label_prop_tab")
                                .then(result => {
                                  if (result == false) {
                                    this.tabIndex = 3;
                                    this.totalTabIndex = 0;
                                    this.total_label_has_error = true;
                                  } else {
                                    this.total_label_has_error = false;
                                    this.$validator
                                      .validateAll("total_layout_prop_tab")
                                      .then(result => {
                                        if (result == false) {
                                          this.tabIndex = 3;
                                          this.totalTabIndex = 1;
                                          this.total_layout_has_error = true;
                                        } else {
                                          this.total_layout_has_error = false;
                                          validated = true;
                                          resolve(validated);
                                        }
                                      });
                                  }
                                });
                            }
                          });
                      }
                    });
                }
              });
            }
          })
          .catch(error => {
            reject("false");
          });
      });
    },
    backtodefault() {
      this.list = JSON.parse(JSON.stringify(this.default_list));
      this.preview();
    },
    // Submit action
    onSubmit() {
      this.validateForm().then(result => {
        if (result) {
          var data = JSON.stringify({
            list: {
              template_list: this.list
            }
          });
          this.$store
            .dispatch("settings/updateprintsettings", {
              id: this.$route.params.id,
              data: data
            })
            .then(() => {
              this.$router.go("-1");
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message:
                  (this.$route.params.id == 3
                    ? "Invoice Print"
                    : this.$route.params.id == 6
                    ? "Quotation Print"
                    : "Credit Print") + " Template has been Saved ",
                type: "success",
                showCloseButton: true
              });
            });
        }
      });
    },
    // Find Logo height by width (height=width*1.22/2)
    findHieght(value) {
      this.header_prop.logo_height = value.newValue * (1.22 / 2);
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store
      .dispatch(
        "settings/fetchprintsettings",
        JSON.stringify({
          id: routeTo.params.id
        })
      )
      .then(() => {
        next();
      });
  },
  computed: {
    list: {
      get() {
        return this.$store.state.settings.template_list;
      },
      set(val) {
        this.$store.state.settings.template_list = val;
      }
    },
    ...mapState({
      default_list: state => state.settings.default_template_list,
      temp_prop: state => state.settings.template_list.temp_prop,
      header_prop: state => state.settings.template_list.header_prop,
      item_prop: state => state.settings.template_list.item_prop,
      total_prop: state => state.settings.template_list.total_prop,
      menu_id: state => state.settings.template_list.menu_id
    })
  }
};
</script>
<style>
.print-temp .input-group input {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right: 0 !important;
}
.print-temp .input-group .input-group-append .input-group-text {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border: 1px solid #acaeaf !important;
  padding: 5px 9px;
}
.print-temp .custom-line-tab .nav-tabs > .nav-item .nav-link.active {
  border-bottom: 2px solid #0675b9 !important;
}
.print-temp .d-inline-block {
  margin: 6px;
}
.forms-elements .colorpicker-wrapper .colorpicker {
  top: 40px !important;
}
.vertical-sidenav.sidenav-container-layout .sidenave-main-content {
  float: right;
  width: calc(100% - 400px);
}
</style>
